// 아티클 본문은 locale별 MDX(src/entities/blog/content/{slug}.{ko,en}.mdx),
// 카드·영상 메타는 locale별 TS 데이터 모듈(blog-data.ko.ts / blog-data.en.ts)에 둔다.
// 짧은 UI 문구(히어로·버튼·탭 라벨 등)만 locales/{ko,en}/blog.json 에서 해석한다(next-intl).

export type BlogTabKey = 'all' | 'notice' | 'release' | 'faq' | 'guide';
type BlogCategoryKey = Exclude<BlogTabKey, 'all'>;

// 탭 키(표시 라벨은 blog.json tabs.<key>). 'all' 은 전체 보기.
// 클라이언트에서도 쓰이므로 locale 데이터 모듈(blog-data.ts)이 아닌 여기에 둔다
// (blog-data.ts 를 import 하면 ko/en 데이터가 클라이언트 번들에 딸려 들어감).
export const BLOG_TAB_KEYS: BlogTabKey[] = [
  'all',
  'notice',
  'release',
  'faq',
  'guide',
];

// 영상 카드. category 는 'PRODUCT' 등 표시용 태그(번역 대상 아님).
export type BlogVideo = {
  key: string;
  category: string;
  duration: string;
  guideHref: string;
  thumbnail?: string;
  youtubeId?: string;
  title: string;
  summary: string;
};

// 게시글 카드. categoryKey 로 필터링, 탭 라벨은 blog.json tabs.<key>.
export type BlogPost = {
  id: number;
  slug: string;
  categoryKey: BlogCategoryKey;
  date: string;
  image?: string;
  title: string;
  description: string;
};

// 아티클 MDX 모듈(content/{slug}.{locale}.mdx)의 `export const metadata` 형태.
// 본문은 MDX 마크다운이 소스이며, 이 메타만 페이지(SEO·JSON-LD·헤더)가 사용한다.
// 본문 이미지(`![]()`)·영상(`<YouTube url />`)은 개수 제한 없이 본문에 직접 쓴다.
export type BlogArticleMetadata = {
  slug: string;
  categoryKey: BlogCategoryKey;
  date: string;
  title: string;
  description: string;
  // OG·JSON-LD 용 대표 썸네일 1장 (본문 이미지와 무관)
  thumbnail?: string;
};
